import * as React from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Back from "./../../components/Back";
import { Stack, CircularProgress } from "@mui/material";
import { Images } from "./../../assets/common";
import LeaderboardRow from "./../../components/LeaderBoardRow";
import NoData from "../../components/Nodata";
import ApiService from "../../services/api-service";
import { getUserId } from "../../constants/function";
import Loader from "./../../components/Loader";
import { useParams } from "react-router-dom";
import LevelCard from "../../components/LevelCard";
import { useTranslation } from "react-i18next";
import { kFormatter } from "../../constants/function";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

export default function LeaderBoard() {
  const { t } = useTranslation("common");
  const { id } = useParams();
  const [loading, setLoading] = React.useState(false);
  const [avgLevel, setavgLevel] = React.useState(0);
  const theme = useTheme();
  const [data, setData] = React.useState({});
  const [creatorData, setCreatorData] = React.useState({});
  const [value, setValue] = React.useState(0);
  const userId = getUserId();
  const handleChange = (event, newValue) => {
    setValue(newValue);
    switch (newValue) {
      case 0:
        setData({});
        getCuratorData(id ? id : userId);
        break;

      case 1:
        setData({});
        getCreatorData(id ? id : userId);
        break;
    }
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const getCuratorData = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.CURATOR_DATA(_id);
      setData({ ...response["result"] });
      setavgLevel(response["result"]["avgLevel"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  const getCreatorData = async (_id) => {
    try {
      setLoading(true);
      const response = await ApiService.CREATOR_DATA(_id);
      setCreatorData({ ...response["result"] });
      setavgLevel(response["result"]["avgLevel"]);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    getCuratorData(id ? id : userId);
  }, []);
  return (
    <Box sx={{ padding: "0 22px 100px 0" }}>
      <Back />
      <Typography
        sx={{ margin: "0 0 20px !important", padding: "0 20px" }}
        className="web_header"
      >
        {t("leaderBoard.title")}
      </Typography>
      <Box
      // sx={{ backgroundColor: "#1E1E1E" }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth"
          aria-label="full width tabs example"
        >
          <Tab label={t("leaderBoard.tabs.tab1")} {...a11yProps(0)} />
          <Tab label={t("leaderBoard.tabs.tab2")} {...a11yProps(1)} />
        </Tabs>
        <Box axis={theme.direction === "rtl" ? "x-reverse" : "x"} index={value}>
          <TabPanel value={value} index={0} dir={theme.direction}>
            <Stack>
              <Box sx={{  py: [4, 3, 1], textAlign: "center", position: "relative" }}>
                <img
                  style={{ padding: "0 18px", maxWidth: "100%" }}
                  className="badgeSize"
                  src={Images.level1}
                />
                <Stack className="avgLevel">
                  <Typography
                    sx={{
                      fontSize: ["48px !important","60px !important", "96px !important"],
                      lineHeight: "1 !important",
                    }}
                  >
                    {avgLevel}
                  </Typography>
                  <Typography
                    className="fs-20"
                    sx={{ color: "#2CF488", letterSpacing: ["12px !important", "24px !important"], }}
                  >
                    {t("leaderBoard.level")}
                  </Typography>
                </Stack>
              </Box>
              <Box
                className="__main_pading"
                sx={{
                  paddingBottom: "100px",
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  gap: "30px",
                }}
              >
                <Stack gap="35px" direction="row">
                  {/* {data["views"] ? (
                    <LevelCard
                      data={data["views"]}
                      width={"33%"}
                      title={"Views"}
                      color="#62FFE1"
                      icon={Images.show}
                      // path="/app/LifetimeCount/Views"
                    />
                  ) : null} */}
                  {/* {data["likes"] ? (
                    <LevelCard
                      data={data["likes"]}
                      width={"25%"}
                      title={"Likes"}
                      color="#FFEE20"
                      icon={Images.likes}
                      // path="/app/LifetimeCount/Likes"
                    />
                  ) : null} */}
                  {data["tips"] ? (
                    <LevelCard
                      isAmount={true}
                      data={data["tips"]}
                      width={"50%"}
                      title={t("leaderBoard.levelCard.header1")}
                      color="#F48706"
                      icon={Images.handHolding}
                      path="/app/LifetimeCount/Tips/curator"
                    />
                  ) : null}

                  {data["listens"] ? (
                    <LevelCard
                      // isAmount={true}
                      data={data["listens"]}
                      width={"50%"}
                      title={t("leaderBoard.levelCard.header2")}
                      color="#00C3FD"
                      icon={Images.listen}
                      path="/app/LifetimeCount/Listens/curator"
                    />
                  ) : null}
                </Stack>
                <Stack gap="35px" direction="row">
                  {data["subscribeMonthly"] ? (
                    <LevelCard
                      data={data["subscribeMonthly"]}
                      width={"100%"}
                      title={t("leaderBoard.levelCard.header3")}
                      color="#FF1CBE"
                      icon={Images.user_add}
                      path="/app/LifetimeCount/SubscribeMonthly/curator"
                    />
                  ) : null}
                </Stack>
                <Stack spacing={1}>
                  <Typography className="fs-14">NFT</Typography>
                  <Stack gap="35px" direction="row">
                    {data["nftOwned"] ? (
                      <LevelCard
                        // isAmount={true}
                        data={data["nftOwned"]}
                        width={"50%"}
                        title={t("leaderBoard.levelCard.header4")}
                        color="#F48706"
                        icon={Images.nft_owned}
                        path="/app/LifetimeCount/NftOwned/curator"
                      />
                    ) : null}
                    {/* Commented as per Requirement */}
                    {/* {data["nftBuy"] ? (
                      <LevelCard
                        data={data["nftBuy"]}
                        width={"25%"}
                        title={"NFT Purchased"}
                        color="#FFEE20"
                        icon={Images.nft_buy}
                        path="/app/LifetimeCount/NftBuy"
                      />
                    ) : null} */}
                    {data["nftMoneyMade"] ? (
                      <LevelCard
                        data={data["nftMoneyMade"]}
                        width={"50%"}
                        title={t("leaderBoard.levelCard.header5")}
                        color="#62FFE1"
                        icon={Images.nft_amount}
                      />
                    ) : null}
                  </Stack>
                </Stack>
                <Stack>
                  <Typography className="fs-14">
                    {t("assetPopup.section2")}
                  </Typography>
                  <Stack gap="35px" direction="row">
                    {data["playlistCreated"] ? (
                      <LevelCard
                        // isAmount={true}
                        data={data["playlistCreated"]}
                        width={"50%"}
                        title={t("leaderBoard.levelCard.header6")}
                        color="#F48706"
                        icon={Images.playlist_add}
                        path="/app/LifetimeCount/PlaylistCreated/curator"
                      />
                    ) : null}
                    {data["playlistStreams"] ? (
                      <LevelCard
                        data={data["playlistStreams"]}
                        width={"50%"}
                        title={t("leaderBoard.levelCard.header7")}
                        color="#00C3FD"
                        icon={Images.playlist}
                        path="/app/LifetimeCount/PlaylistStreams/curator"
                      />
                    ) : null}
                  </Stack>
                </Stack>
                {data.length === 0 ? (
                  <NoData lable={t("noData.noData")} />
                ) : null}
              </Box>
            </Stack>
          </TabPanel>
          <TabPanel value={value} index={1} dir={theme.direction}>
            <Stack>
              <Box sx={{ py: [4, 3, 1], textAlign: "center", position: "relative" }}>
                <img
                 style={{ padding: "0 18px", maxWidth: "100%" }}
                  className="badgeSize"
                  src={Images.level1}
                />
                <Stack className="avgLevel">
                  <Typography
                    sx={{
                      fontSize: ["48px !important","60px !important", "96px !important"],
                      lineHeight: "1 !important",
                    }}
                  >
                    {avgLevel}
                  </Typography>
                  <Typography
                    className="fs-20"
                    sx={{ color: "#2CF488", letterSpacing: ["12px !important", "24px !important"], }}
                  >
                    {t("leaderBoard.title")}
                  </Typography>
                </Stack>
              </Box>
              <Box
                className="__main_pading"
                sx={{ position: "relative", paddingBottom: "100px" }}
              >
                <Stack gap="35px" direction="row">
                  {creatorData["songReleased"] ? (
                    <LevelCard
                      data={creatorData["songReleased"]}
                      width={"50%"}
                      title={t("leaderBoard.levelCard.header8")}
                      color="#00C3FD"
                      icon={Images.listen}
                      path="/app/LifetimeCount/SongReleased/creator"
                    />
                  ) : null}
                  {creatorData["nftSellAmount"] ? (
                    <LevelCard
                      data={creatorData["nftSellAmount"]}
                      width={"50%"}
                      isAmount={true}
                      title={t("leaderBoard.levelCard.header9")}
                      color="#2CF488"
                      icon={Images.nft_amount}
                      path="/app/LifetimeCount/NftSold/creator"
                    />
                  ) : null}
                </Stack>
                <Stack gap="35px" direction="row" marginTop="30px">
                  {creatorData["playlistAdd"] ? (
                    <LevelCard
                      data={creatorData["playlistAdd"]}
                      width={"50%"}
                      title={t("leaderBoard.levelCard.header10")}
                      color="#FFEE20"
                      icon={Images.playlist_add}
                      path="/app/LifetimeCount/PlaylistAdd/creator"
                    />
                  ) : null}
                  {creatorData["playlistStreams"] ? (
                    <LevelCard
                      data={creatorData["playlistStreams"]}
                      width={"50%"}
                      title={t("leaderBoard.levelCard.header11")}
                      color="#00C3FD"
                      icon={Images.playlist}
                      path="/app/LifetimeCount/SongStreamed/creator"
                    />
                  ) : null}
                </Stack>
                <Stack gap="35px" direction="row" marginTop="30px">
                  {/* {creatorData["sharedLink"] ? (
                    <LevelCard
                      data={creatorData["sharedLink"]}
                      width={"100%"}
                      title={"Share"}
                      color="#FFEE20"
                      icon={Images.playlist_add}
                      path="/app/LifetimeCount/sharedLink/creator"
                    />
                  ) : null} */}
                  {creatorData["sharedLink"] ? (
                    <Box className="__level_widget" sx={{ width: "100%" }}>
                      <Stack direction="row" justifyContent="space-between">
                        <Stack direction="row" gap="10px">
                          <img
                            style={{ width: "30px" }}
                            src={Images.share_link}
                            alt="icon"
                          />
                          <Typography>{t("shareLink")}</Typography>
                        </Stack>
                        <Stack>
                          <Typography>{t("count")}</Typography>
                        </Stack>
                      </Stack>
                      <Stack>
                        <Typography className="faded ml_auto fs-30">
                          {creatorData["sharedLink"]["count"]
                            ? kFormatter(creatorData["sharedLink"]["count"])
                            : 0}
                        </Typography>
                      </Stack>
                    </Box>
                  ) : null}
                </Stack>
                {data.length === 0 ? (
                  <NoData lable={t("noData.noData")} />
                ) : null}
              </Box>
            </Stack>
          </TabPanel>
        </Box>
        {loading ? <Loader /> : null}
      </Box>
    </Box>
  );
}
